<template>
    <button type="button"
            class="hold-button"
            :class="{'active': !!this.timeoutId}"
            :style="{'--hold-button-transition-speed': `${this.time / 1000}s`}"
            @mousedown.prevent="start"
            @mouseup.prevent="reset"
            @mouseleave="reset"
            @touchstart="start"
            @touchcancel="reset"
            @touchend="reset"
    >
        <slot />
    </button>
</template>

<script>
export default {
    name: "HoldButton",
    props: {
        time: {type: Number, default: 1000},
        resetOnComplete: {type: Boolean, default: true},
    },

    data() {
        return {
            timeoutId: null,
            hasCompleted: false,
        };
    },

    methods: {
        start() {
            this.reset();

            this.timeoutId = setTimeout(() => {
                this.$emit('completed');
                this.hasCompleted = true;
                this.reset();
            }, this.time);
        },

        reset() {
            if (!this.resetOnComplete && this.hasCompleted) {
                return;
            }
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
            this.timeoutId = null;
        },
    }
}
</script>

<style scoped>
.hold-button {
    user-select: none;
    /* As of 2024, Apple still requires this prefix */
    -webkit-user-select: none;
}
</style>
